import { MutableRefObject, createContext, useContext, useEffect, useRef, useState } from 'react'

import { checkListingHasBeenVisited, storePropertyVisited } from '@/utils/new-property'

type RelatedAdsBannerContextType = {
  handleUserClickOnBanner: () => void
  hasUserClickedOnBanner: boolean
  showRelatedAdsBanner: boolean
  similarPropertiesPhotosUrl: string[]
  similarPropertiesRef: MutableRefObject<HTMLDivElement>
}

type RelatedAdsBannerContextProps = {
  isDirectPageVisit: boolean
  listingId: string
  similarPropertiesPhotosUrl: string[]
}

const RelatedAdsBannerContext = createContext<RelatedAdsBannerContextType>({
  handleUserClickOnBanner: () => {},
  hasUserClickedOnBanner: false,
  showRelatedAdsBanner: false,
  similarPropertiesPhotosUrl: [],
  similarPropertiesRef: null,
})

export const RelatedAdsBannerProvider: React.FC<RelatedAdsBannerContextProps> = ({
  children,
  isDirectPageVisit,
  listingId,
  similarPropertiesPhotosUrl,
}) => {
  const [hasUserClickedOnBanner, setHasUserClickedOnBanner] = useState(false)
  const similarPropertiesRef = useRef<HTMLDivElement>(null)
  const hasListingBeenVisited = checkListingHasBeenVisited(listingId)
  const showRelatedAdsBanner = isDirectPageVisit && similarPropertiesPhotosUrl.length > 0 && !hasListingBeenVisited

  const handleUserClickOnBanner = () => {
    setHasUserClickedOnBanner(true)
  }

  return (
    <RelatedAdsBannerContext.Provider
      value={{
        handleUserClickOnBanner,
        hasUserClickedOnBanner,
        showRelatedAdsBanner,
        similarPropertiesPhotosUrl,
        similarPropertiesRef,
      }}
    >
      {children}
    </RelatedAdsBannerContext.Provider>
  )
}

export const useRelatedAdsBanner = () => useContext(RelatedAdsBannerContext)
